import React from 'react'
import { Modal } from '../../../components/_EOS/Modal'
import { ModalReturnType } from '../../../hooks/useModal'
import { Asn } from '../../../interfaces/Asn/Asn'

interface ASNDeleteModalProps {
  deleteModalState: ModalReturnType<Asn>
  onConfirm: (asn: Asn) => void
}

export const ASNDeleteModal: React.FC<ASNDeleteModalProps> = ({
  deleteModalState,
  onConfirm
}) => {
  const handleConfirm = () => {
    if (deleteModalState.extendedProps) {
      onConfirm(deleteModalState.extendedProps)
    }
  }

  return (
    <Modal
      open={deleteModalState.isOpen}
      maxWidth={deleteModalState.size}
      title={deleteModalState.title}
      onClose={deleteModalState.closeModal}
      successButton={{
        action: handleConfirm,
        title: 'Confirmar'
      }}
      cancelButton={{
        action: () => deleteModalState.closeModal(),
        title: 'Cancelar'
      }}
    >
      ¿Desea eliminar el ASN <strong>{deleteModalState.extendedProps?.asnId} - {deleteModalState.extendedProps?.asnNumber}</strong>?
    </Modal>
  )
}

